<template>
    <div id="go_BirthdayForm">
    <v-form>
        <v-layout row wrap>
            <v-flex align-self-center xs12 sm12 md12 text-md-right>
                <label class="pl-2 pr-2" style="color:grey;">{{cLabel}}</label>
                <input type="hidden" :value="dateValue.day + dateValue.month + dateValue.year"/>
            </v-flex>       
            <v-flex xs3 sm3 md3>
                    <v-select
                    :items="getDays()"
                    label="Day"
                    outline
                    v-model="dateValue.day"
                    :background-color="isRequired"
                    ></v-select>                
            </v-flex>
            <v-flex xs5 sm5 md5>
                    <v-select
                    :items="getMonths()"
                    outline
                    label="Month"
                    v-model="dateValue.month"
                    :background-color="isRequired"
                    ></v-select>                
            </v-flex>        
            <v-flex xs4 sm4 md4>
                    <v-select
                    :items="getYears()"
                    outline
                    label="Year"
                    v-model="dateValue.year"
                    :background-color="isRequired"
                    ></v-select>                
            </v-flex>                  
        </v-layout>
    </v-form>
    </div>

</template>

<script>
import Helper from '../helper';

export default {
    created(){
    },
    props:[
        "label","required",
    ],
    updated(){
        this.emitDate();
    },
    data(){
        return {
            emitters:{
                value:"emDateValue",
            },
            dateValue:{
                day:null,
                month:null,
                year:null,
            },
            helper:Helper,
        }
    },
    computed:{
        isRequired(){
            if (this.required==true){
                return Helper.colors.required;
            }else{
                return "";
            }
        },
        cLabel(){
            let label= this.label;
            if (label!=null && label.trim()!=""){
                return label;
            }else{
                return "";
            }
        },
    },
    methods:{
        emitDate(){
            this.$emit(this.emitters.value,this.dateValue);
        },
        getDays(){
            let daysOfMonth= [];
            for (let i=1;i<=31;i++){
                let dateText = i;

                if (i<10){
                    dateText = "0"+ i;
                }

                daysOfMonth.push(dateText);
            }
            return daysOfMonth;
        },
        getMonths(){
            let values = ["01","02","03","04","05","06","07","08","09","10","11","12"];
            let texts = ["January","February","March","April","May","June","July","August","September","October","November","December"];
            let months = [];
            values.forEach((val,index)=>{
                months.push({value:val,text:texts[index]});
            });
            return months;
        },
        getYears(){
            let years = [];
            let currYear = 2019;
            for (let i = currYear;i>currYear-108;i--){
                years.push(i);
            }
            return years;
        }
    }
}
</script>

<style>
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot{
    border-color:#f0f3f5;
}
#go_BirthdayForm > form > div > div.flex > div{
    margin: 0 2px 0 2px;
}
#go_BirthdayForm > form > div > div.flex > div > div > div.v-input__slot{
    height: 56px;
}
</style>